import React from "react"
import makeStyles from "@material-ui/core/styles/makeStyles"
import useTheme from "@material-ui/core/styles/useTheme"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import Typography from "@material-ui/core/Typography"
import Box from "@material-ui/core/Box"
import ButtonGroup from "@material-ui/core/ButtonGroup"
import Button from "@material-ui/core/Button"
import CallOutlined from "@material-ui/icons/CallOutlined"
import EmailOutlined from "@material-ui/icons/EmailOutlined"
import MuiLink from "@material-ui/core/Link"
import { FaWhatsapp } from "react-icons/fa"

const useStyles = makeStyles(theme => ({
  HeaderContact: {
    padding: theme.spacing(0.3, 1.6),
    background: theme.palette.secondary.main,
  },
  lowerCase: {
    textTransform: "lowercase",
  },
}))
const HeaderContact = () => {
  const classes = useStyles(),
    theme = useTheme(),
    matches = useMediaQuery(theme.breakpoints.down("xs"))

  return (
    <Box className={classes.HeaderContact}>
      <ButtonGroup className={classes.ButtonGroup} fullWidth={true}>
        <Button
          variant="outlined"
          component={MuiLink}
          color="primary"
          underline="none"
          href="tel:+234-813-937-7764"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Gloone events business contact number"
          startIcon={<CallOutlined />}
        >
          {!matches && <Typography>Call</Typography>}
        </Button>
        <Button
          variant="outlined"
          component={MuiLink}
          color="primary"
          underline="none"
          href="https://api.whatsapp.com/send?phone=2348139377764"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Gloone events Whatsapp contact number"
          startIcon={<FaWhatsapp />}
        >
          {!matches && <Typography>Chat</Typography>}
        </Button>
        <Button
          variant="outlined"
          component={MuiLink}
          color="primary"
          underline="none"
          href="mailto:&#103;&#108;&#111;&#111;&#110;&#101;&#101;&#118;&#101;&#110;&#116;&#115;&#064;&#103;&#109;&#097;&#105;&#108;&#046;&#099;&#111;&#109;"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Gloone events Email address"
          startIcon={<EmailOutlined />}
        >
          {!matches && (
            <Typography className={classes.lowerCase}>Email</Typography>
          )}
        </Button>
      </ButtonGroup>
    </Box>
  )
}

export default HeaderContact
